/**
 * @(#)2019/8/26.
 * YxAction，行为组件，用于处理按钮逻辑 总体控制
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React, { cloneElement } from "react";
import { typeList } from "./tools";
import BaseAction from "./BaseAction";
import PackUpAction from "./PackUpAction";
import { get, merge, random, toArray } from "../../utils";
import { YxComponent, Route, Connection } from "../YxComponent";
import { omit } from "lodash";

class YxActions extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.divClassName = ["yx_actions_box"];
  }

  static typeList = typeList;

  /**
   * 选择正确的样式类型
   *
   * @memberof YxActions
   */
  choseClass = (group) => {
    const source = toArray(group);
    const errorClass = "yx_yxAction_error"; // 表示采取了不建议的组合方式
    if (source.length <= 0) {
      return errorClass;
    } else {
      const dict = {
        tag: "yx_yxAction_size_tag",
        link: "yx_yxAction_size_link",
        icon: "yx_yxAction_size_icon",
        button: "yx_yxAction_size_button",
      };
      const styleList = Object.keys(dict);
      const groupStyles = source.map((item) =>
        get(item, "styleType", "button")
      );
      for (let type of styleList) {
        const target = groupStyles.filter((s) => s === type);
        if (target.length === groupStyles.length) {
          return dict[type];
        }
      }
      return errorClass;
    }
  };

  /**
   * 当其为一组时调用
   *
   * @memberof YxActions
   */
  groupParse = (group) => {
    const data = get(this.props, "iocData", {});
    return group.map((item, idx) => {
      const publiceParam = { ...get(this.props, "publiceParam", {}) };
      publiceParam.form = publiceParam.form || get(this.props, "form", null);
      if (item instanceof Function) {
        return item(data);
      } else if (React.isValidElement(item)) {
        return cloneElement(item, { key: item.key || idx }); //解决 key 警告问题
        // return item
      } else if (item.render instanceof Function) {
        return cloneElement(item.render(data, item), { key: item.key || idx });
      } else {
        let children = get(item, "children", null);
        if (children instanceof Function) {
          return children(data);
        } else if (React.isValidElement(children)) {
          return cloneElement(children, { key: children.key || idx }); //解决 key 警告问题
          // return children;
        }
      }
      return <BaseAction key={idx} {...merge(publiceParam, item)} />;
    });
  };

  groupProcess = (group) => {
    const data = get(this.props, "iocData", {});
    // const packUpList = group.filter(item => item.packUp === true)
    const packUpList = group.filter((item) => {
      if (typeof item.packUp === "function") {
        return item.packUp(data, item);
      } else {
        return item.packUp === true;
      }
    });

    if (get(packUpList, "length", 0) <= 0) {
      return group;
    } else {
      const result = group.filter((item) => {
        if (typeof item.packUp === "function") return false;
        return item.packUp !== true;
      });
      const DOM = (
        <PackUpAction
          packUpList={packUpList}
          {...get(this.props, "packUpParam", {})}
        />
      );
      return [DOM, ...result];
    }
  };

  renderActions = (group) => {
    const className = this.parentClass + ` ${this.choseClass(group)}`;
    const group_ = this.groupProcess(group);
    return <div className={className}>{this.groupParse(group_)}</div>;
  };

  render() {
    const group = get(this.props, "group", null);
    if (group instanceof Array) {
      if (get(group, "length", 0) !== 0) {
        return this.renderActions(group);
      }
      return "";
    }

    return <BaseAction {...omit(this.props, ["iocData"])} />;
  }
}

export default YxActions;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/YxAction.js